/**
 * terminal type. this was copied from libssh and  can not be changed
 */
export var TerminalType;
(function (TerminalType) {
    TerminalType[TerminalType["PtyNone"] = 0] = "PtyNone";
    TerminalType[TerminalType["PtyTerminalVanilla"] = 1] = "PtyTerminalVanilla";
    TerminalType[TerminalType["PtyTerminalVT100"] = 2] = "PtyTerminalVT100";
    TerminalType[TerminalType["PtyTerminalVT102"] = 3] = "PtyTerminalVT102";
    TerminalType[TerminalType["PtyTerminalVT220"] = 4] = "PtyTerminalVT220";
    TerminalType[TerminalType["PtyTerminalAnsi"] = 5] = "PtyTerminalAnsi";
    TerminalType[TerminalType["PtyTerminalXterm"] = 6] = "PtyTerminalXterm";
})(TerminalType || (TerminalType = {}));
;
//# sourceMappingURL=definitions.js.map